export default __webpack_public_path__ + "static/media/content1pre1.adc3db1d.jpg";